"use strict";
// InlineSelectInputStyles.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const css_in_js_1 = require("../../components/css-in-js");
exports.styles = {
    host: (0, css_in_js_1.css) `
        display: inline-block;
        font: inherit;
        cursor: pointer;
    `,
    wrap: (0, css_in_js_1.css) `
        position: relative;
        width: 100%;
        cursor: pointer;
    `,
    inlineSelect: (0, css_in_js_1.css) `
        background: #f3f3f4;
        border-radius: 4px;
        padding: 6px 8px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        position: relative;
        outline: none;
        cursor: pointer;
        user-select: none;
    `,
    inlineSelectFocus: (0, css_in_js_1.css) `
        outline: 2px solid #7c3aed33;
        outline-offset: 2px;
        cursor: pointer;
    `,
    inlineLabel: (0, css_in_js_1.css) `
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
        color: #6c6c79;
        white-space: nowrap;
        cursor: pointer;
    `,
    inlineValue: (0, css_in_js_1.css) `
        font-size: 13px;
        line-height: 18px;
        font-weight: 600;
        color: #3f3e51;
        white-space: nowrap;
    `,
    inlinePlaceholder: (0, css_in_js_1.css) `
        font-weight: 400;
        color: #b0b0bc;
    `,
    inlineIcon: (0, css_in_js_1.css) `
        display: inline-flex;
        align-items: center;
        margin-left: 6px;
        opacity: 0.85;
    `,
    disabled: (0, css_in_js_1.css) `
        opacity: 0.6;
        cursor: not-allowed;
    `,
    // dropdown menu (design on right)
    menu: (0, css_in_js_1.css) `
        position: absolute;
        left: 0;
        top: calc(100% + 4px);
        min-width: 100%;
        width: max-content;
        background: #ffffff;
        border-radius: 8px;
        overflow: hidden;
        z-index: 1000;
        cursor: pointer;

        box-shadow: 0 20px 60px rgba(16, 24, 40, 0.18);
    `,
    list: (0, css_in_js_1.css) `
        max-height: 320px; // Might not need this
        overflow: auto;
        padding: 8px 0px;
    `,
    divider: (0, css_in_js_1.css) `
        height: 1px;
        background: rgba(229, 229, 234, 1);
        margin: 0 8px;
    `,
    option: (0, css_in_js_1.css) `
        padding: 0px 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        cursor: pointer;
        background: #fff;
    `,
    optionActive: (0, css_in_js_1.css) `
        // background: rgba(59, 130, 246, 0.08);
        // background: none;
    `,
    optionDisabled: (0, css_in_js_1.css) `
        opacity: 0.5;
        cursor: not-allowed;
    `,
    optionText: (0, css_in_js_1.css) `
        font-size: 14px;
        line-height: 16px;
        font-weight: 300;
        color: #3f3e51;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 8px;
    `,
    optionTextSelected: (0, css_in_js_1.css) `
        font-weight: 600;
    `,
    optionRight: (0, css_in_js_1.css) `
        display: inline-flex;
        min-width: 14px;
        align-items: center;
        justify-content: flex-end;
        margin-right: 8px;
    `,
    check: (0, css_in_js_1.css) `
        color: #3b82f6;
    `,
    empty: (0, css_in_js_1.css) `
        padding: 8px 8px;
        color: #6c6c79;
        font-size: 14px;
    `,
};
//# sourceMappingURL=InlineSelectStyles.js.map